import {
  UpdateProductTabDef,
  UpdateProductTabKind,
} from '../interfaces/Product/UpdateProductTab';
import { UpdateProductDetails } from '../pages/Product/UpdateProduct/UpdateProductDetails';
import { UpdateProductOptions } from '../pages/Product/UpdateProduct/UpdateProductOptions/UpdateProductOptions';
import { UpdateProductMediaTab } from '../pages/Product/UpdateProduct/UpdateProductMediaTab';
import { UpdateRelatedProducts } from '../pages/Product/UpdateProduct/UpdateRelatedProducts/UpdateRelatedProducts';
import { UpdateProductSEO } from '../pages/Product/UpdateProduct/UpdateProductSEO/UpdateProductSEO';

export const availableUpdateProductTabs: UpdateProductTabDef[] = [
  {
    kind: UpdateProductTabKind.DETAILS,
    name: 'Ürün Bilgileri',
    path: 'details',
    element: UpdateProductDetails,
  },
  {
    kind: UpdateProductTabKind.MEDIA,
    name: 'Medya',
    path: 'media',
    element: UpdateProductMediaTab,
  },
  {
    kind: UpdateProductTabKind.OPTIONS,
    name: 'Varyantlar',
    path: 'options',
    element: UpdateProductOptions,
  },
  {
    kind: UpdateProductTabKind.SEO,
    name: 'SEO',
    path: 'seo',
    element: UpdateProductSEO,
  },
  {
    kind: UpdateProductTabKind.RELATED_PRODUCTS,
    name: 'İlgili Ürünler',
    path: 'related-products',
    element: UpdateRelatedProducts,
  },
];
